import { createComponent } from '../core/create-component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import 'tiny-warning';
import 'react';
const TableTextNewLine = createComponent({
  displayName: 'TableTextNewLine',
  root: 'span',
  propConfig: {
    classNames: ['swan-table-new-line']
  }
});
const TableTextSecondLine = deprecatedComponent({
  displayName: 'TableTextSecondLine',
  root: TableTextNewLine,
  description: 'Use TableTextNewLine component Instead'
});
export { TableTextNewLine, TableTextSecondLine };